export default {
	setCashBalance: (state, cashBalance) => {
		state.cashBalance = cashBalance;
	},
	setAccountShareBalance: (state, accountShareBalance) => {
		state.accountShareBalance = accountShareBalance;
	}
};
